export default function getMenuItemId(id, position) {
  return (id || '') + "-item-" + position;
}